<div class="px-3 py-5 lg:px-6">
	<h2 class=" w-fit text-2xl font-semibold">Achievements</h2>
	<ul class="list-outside list-disc px-6 py-4">
		<li>
			4th place at <a class="underline" href="https://icpc.global/">ICPC 2018</a> Asia-Gwalior Regionals.
		</li>
		<li>
			Winner of <a class="underline" href="https://hack-the-league.devpost.com/"
				>Hack The League - Microsoft Track</a
			>.
		</li>
		<li>
			7th place in <a class="underline" href="https://dsckiit.in/">DSC Garage India Hack</a>.
		</li>
		<li>
			5* <a class="underline" href="https://www.hackerrank.com/">HackerRank</a>(Problem Solver).
		</li>
		<li>Google Hash Code 2020, 7th in University.</li>
		<li>Google Hash Code 2021 5th in University.</li>
		<li>Google Code Jam 2020 world rank 6667.</li>
		<li>
			One of the first 50 codebreakers in <a class="underline" href="https://breakthecode.tech/"
				>BreakTheCode.</a
			>
		</li>
		<li>
			DigitalOcean <a class="underline" href="https://hacktoberfest.digitalocean.com/"
				>HacktoberFest 2020, 2021</a
			> opensource contributor.
		</li>
	</ul>
</div>
<div class="px-3 py-5 lg:px-6">
	<h2 class=" w-fit text-2xl font-semibold">Skills</h2>
	<ul class="list-outside list-disc px-6 py-4">
		<li>
			<span class="font-medium">Languages: </span> C, C++, Python, Java, JavaScript, Typescript, SQL,
			Go.
		</li>
		<li>
			<span class="font-medium">Frameworks: </span> Django, Node, React JS, Next JS, Angular, Electron,
			Svelte, SvelteKit.
		</li>
		<li>
			<span class="font-medium">Technologies: </span>Git, CI/CD, AWS, Azure, GCP, UI/UX, Figma,
			Docker, Elasticsearch.
		</li>
	</ul>
</div>
